import reducer from "./reducer";
export { default as OnboardingProcesses } from "./components/index";
export { default as onboardingProcessesReducerName } from "./constants";
export default reducer;
